import {useEffect, useState} from 'react';
import {useWebsocket} from '../components/socketContext/socketContext';
import {subscribeApiSocket} from '../api/socket';
import {fetchGame, getSubscriptionId} from '../api/api';
import {useQueryClient, useQuery} from 'react-query'
import RouteUtils from '../utils/routeUtils'

export const useGameQuery = (league, awayTeam, homeTeam, gameTime) => {
    const [game, setGame] = useState();
    const queryClient = useQueryClient();
    const socket = useWebsocket();
    const [enabled, setEnabled] = useState(true);

    // Remove trailing slashes
    gameTime = gameTime.replace(/\/$/, "");
    const leagueFilter = RouteUtils.getLeague(league);

    const query = useQuery(['game', {league, homeTeam, awayTeam, date: gameTime}],
        () => fetchGame(leagueFilter, awayTeam, homeTeam, gameTime), {
            enabled,
            retry: (count, {message: status}) => (status !== '404' && status !== '401' && status !== '500')
        });

    const handleSocketMessage = async (m) => {
        let data = JSON.parse(m.data);
        if (!data || !data.matchupId) {
            console.warn(`Socket ignoring unexpected message: ${JSON.stringify(data)}`);
            return;
        }
        if (data.eventName === 'line_updated') {
            let newGame = {...game};
            data.data.newValue.forEach(value => {
                value['updated'] = true;
            });
            if (newGame.markets) {
                newGame.markets[data.data.marketName][data.data.bookName] = data.data.newValue;
                setGame(newGame);
                let updatedGame = {...newGame};
                let timer = setTimeout(() => {
                    for (let market in updatedGame.markets) {
                        for (let book in updatedGame.markets[market]) {
                            updatedGame.markets[market][book].forEach(value => {
                                value['updated'] = false;
                            });
                        }
                    }
                    setGame(updatedGame);
                    clearTimeout(timer);
                }, 60000);
            }
        } else if (data.eventName === 'status_updated') {
            let newGame = {...game, ...data.data};
            setGame(newGame);
        }
    }

    const handleSocketOpen = () => {
        if (data) {
            subscribeApiSocket(socket, [data.id]);
        }
    }

    const {isLoading, data, isError} = query;

    useEffect(() => {
        socket.addEventListener('message', handleSocketMessage);
        socket.addEventListener('open', handleSocketOpen);

        return () => {
            socket.removeEventListener('message', handleSocketMessage);
            socket.removeEventListener('open', handleSocketOpen)
        }
    }, []);

    useEffect(() => {
        if (!data)
            return;

        setGame(data);
        setEnabled(false);

        queryClient.setQueryData(['game', {league, homeTeam, awayTeam, date: gameTime}], data);
        subscribeApiSocket(socket, [data.id]);
    }, [data])

    return {isLoading, game, isError};
}